export const SUBSCRIPTIONS_PUBLIC_GET_LITTER_PRICING_INFO_METHOD = "GET";
export const SUBSCRIPTIONS_PUBLIC_GET_LITTER_PRICING_INFO_PATH = "/litter/pricing";
